import React from 'react';
import { twMerge } from 'tailwind-merge';

// Title block shown under the Event and CreativeWork players and countdown
// cards. dateTime is the event start time or creative work release time.
export const TitleAndDescription = ({
  title,
  description,
  dateTime,
  locale = 'en',
  className,
}: {
  title: string;
  description: string;
  dateTime: string;
  locale?: string;
  className?: string;
}) => {
  return (
    <div className={twMerge("mt-3 mb-6 m-event-details-ctn px-4 text-left w-full", className)}>
      <div className="text-base md:text-xl m-event-title text-base-content font-medium">{title}</div>
      {dateTime ? (
        <div className="text-sm md:text-base text-base-content/70 m-event-start-time">
          {new Date(dateTime || "").toLocaleDateString(locale || "default", {
            month: "long",
            year: "numeric",
            day: "numeric",
          })}{" "}
          - {new Date(dateTime || "").toLocaleTimeString(locale || "default", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      ) : null}
      {description && (
        <div className="text-xs md:text-sm text-base-content/60 uppercase">{description}</div>
      )}
    </div>
  );
};
